// extracted by mini-css-extract-plugin
var _1 = "cB1S2POHvt";
var _2 = "r2eWYy6vsb";
export { _1 as "linkButton", _2 as "root" }
